import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServerResponse } from '../models/ServerResponse';
import { ContactFormFields } from '../modules/contact/classes/ContactFormFields';
import { Observable } from 'rxjs';
import { ContactDialogComponent } from '../modules/contact/dialogs/contact-dialog/contact-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
	providedIn: 'root'
})
export class ContactService {

	readonly API_CONTACT_URL : string;

	constructor(private http:HttpClient,
				private matDialog:MatDialog) {
		this.API_CONTACT_URL = environment.API_URL + "/user/contact-form";
	}

	openDialog() {
		this.matDialog.open(ContactDialogComponent);
	}
	send(fields:ContactFormFields) : Observable<ServerResponse<boolean>> {
		return this.http.post<ServerResponse<boolean>>(this.API_CONTACT_URL, fields);
	}
}
